export default __webpack_public_path__ + "static/media/Type-F.ff1d1f48.jpg";